import { render, staticRenderFns } from "./localNewsList.vue?vue&type=template&id=c659dae8&scoped=true&"
import script from "./localNewsList.vue?vue&type=script&lang=js&"
export * from "./localNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c659dae8",
  null
  
)

export default component.exports